export default __webpack_public_path__ + "static/media/ROC.8400d746.svg";